<template>
	<div v-el:offset-root class="row collapse">
		<div class="small-12 medium-2 large-1 columns date">
			<race-list-date-label :date="date"></race-list-date-label>
		</div>
		<div class="small-12 medium-10 large-11 columns loader">
			<race :race="firstRace"></race>
		</div>
	</div>
	<div class="row collapse" v-for="race in otherRaces">
		<div class="small-12 medium-10 medium-offset-2 large-11 large-offset-1 columns loader">
			<race :race="race"></race>
		</div>
	</div>
</template>

<script>
	import moment from 'moment'
	import Race from './Race.vue'
	import RaceListDateLabel from './RaceListDateLabel.vue'
	export default {
		components: { Race, RaceListDateLabel },
		props: ['date', 'races', 'group'],
		data () {
			return {
				daysInRacing: [],
				activeDayInRacing: 0,
				daysInRacingVisible: false
			};
		},
		computed: {
			firstRace () {
				return this.races[0];
			},
			otherRaces() {
				return this.races.slice(1);
			}
		}
	}
</script>



/** WEBPACK FOOTER **
 ** RaceListDate.vue?04360102
 **/